module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-metals-remnants.2ced065d.png";